export default __webpack_public_path__ + "static/media/Logo@2x.632e1cbc.png";